import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { FingerSDK } from "@identy/identy-finger";
if (environment.production) {
  enableProdMode();
}

// FingerSDK.preInitialize(environment.license);
// FingerSDK.preInitialize(environment.license, {
//   modelURL:  `${environment.finger_url}/api/v1/models`,
// });
let modelURL = environment.finger_url + "/api/v1/models"

// FingerSDK.preInitialize({modelURL: modelURL}).catch(err => {
//   console.error(err);
// });

// FingerSDK.preInitialize({
//   URL: `${environment.finger_url}/api/v1/models`
// },{
//   URL: {
//     url: `${environment.finger_url}/api/v1/pub_key`,
//     headers: [{
//       name: "LogAPITrigger",
//       value: "true"
//     }]
//   },
// }).catch(err => {
//   console.error(err);
// });

// platformBrowserDynamic()
//   .bootstrapModule(AppModule)
//   .catch((err) => console.error(err));


async function initializeApp() {
  try {
    await FingerSDK.preInitialize(
      {
        URL: `${environment.finger_url}/api/v1/models`
      },
      {
        URL: {
          url: `${environment.finger_url}/api/v1/pub_key`,
          headers: [
            {
              name: "LogAPITrigger",
              value: "true",
            },
            {
              name: "Content-Type",
              value: "application/json",
            }
          ],
        },
      }
    );
    console.log("FingerSDK initialized successfully.");

    // Bootstrap the Angular module after successful initialization
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  } catch (err) {
    console.error("Error initializing FingerSDK:", err);
  }
}

initializeApp();


if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    "use strict";

    // @ts-ignore
    if (search instanceof RegExp) {
      throw TypeError("first argument must not be a RegExp");
    }
    if (start === undefined) {
      start = 0;
    }
    return this.indexOf(search, start) !== -1;
  };
}
